import { render, staticRenderFns } from "./PerCurrency.vue?vue&type=template&id=65192187&scoped=true&"
import script from "./PerCurrency.vue?vue&type=script&lang=js&"
export * from "./PerCurrency.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65192187",
  null
  
)

export default component.exports